'use client'

import type { CarouselSlideProps } from '@pearlconvert/ui/components/carousel/carousel.types'

import { useTranslations } from 'next-intl'
import { useEffect, useRef } from 'react'

export default function CarouselSlide({
  children,
  name,
  slidesRef,
  index,
}: CarouselSlideProps) {
  const t = useTranslations('ui')
  const slideRef = useRef<HTMLLIElement>(null)

  useEffect(() => {
    slidesRef.current[index] = slideRef.current ?? null
  }, [index, slidesRef])

  return (
    <li
      ref={slideRef}
      className="carousel__slide"
      aria-roledescription="slide"
      aria-label={`${name || t('carousel.item')} ${index + 1}`}
    >
      {children}
    </li>
  )
}
